module.exports = __webpack_public_path__ + "img/circle_num_2_red.7f1e8be2.svg";